import { render, staticRenderFns } from "./PaymentTypeBadge.vue?vue&type=template&id=13701feb&scoped=true"
import script from "./PaymentTypeBadge.vue?vue&type=script&lang=js"
export * from "./PaymentTypeBadge.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypeBadge.vue?vue&type=style&index=0&id=13701feb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13701feb",
  null
  
)

export default component.exports